import { UploadFileRounded } from '@mui/icons-material'
import { Avatar, Box, ButtonBase, Typography } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import VisuallyHiddenInput from './inputs/VisuallyHiddenInput'
import { snackbar } from '../services/SnackbarService'

interface P {
    setSelectedFiles: React.Dispatch<React.SetStateAction<File[]>>
    size?: 'medium' | 'small'
    disable?: boolean
}

function FileUpload({ setSelectedFiles, disable, size }: P) {
    const ref = useRef<HTMLLabelElement>()
    const [localSelectedFiles, setLocalSelectedFiles] = useState<File[]>()

    useEffect(() => {
        setSelectedFiles(localSelectedFiles)
    }, [localSelectedFiles])

    const onSelection = (list: FileList) => {
        const files = []
        for (let i = 0; i < list.length; i++) {
            const element = list[i]

            if (element.type.startsWith('image/')) {
                if (!element.type.includes('png') && !element.type.includes('jpeg')) {
                    snackbar.show({ severity: 'warning', text: 'This image type is not supported. Supported type: "png" or "jpeg"' })
                    continue
                }
            }

            files.push(element)
        }
        setLocalSelectedFiles(files)
    }

    const height = size === 'small' ? 13 : 20
    const fontPrimarySieze = size === 'small' ? '.8rem' : '1rem'
    const fontSecondarySieze = size === 'small' ? 8 : 12
    const avatarSize = size === 'small' ? 30 : 40

    return (
        <div
            onDragEnter={e => {
                e.preventDefault()
                e.stopPropagation()
                ref.current.classList.add('is-dragging')
            }}
            onDragOver={e => {
                e.preventDefault()
                e.stopPropagation()
                ref.current.classList.add('is-dragging')
            }}
            onDragLeave={e => {
                e.preventDefault()
                e.stopPropagation()
                ref.current.classList.remove('is-dragging')
            }}
            onDragEnd={e => {
                e.preventDefault()
                e.stopPropagation()
                ref.current.classList.remove('is-dragging')
            }}
            onDrop={e => {
                e.preventDefault()
                e.stopPropagation()

                ref.current.classList.remove('is-dragging')
                onSelection(e.dataTransfer.files)
            }}>

            <form>
                <ButtonBase
                    ref={ref}
                    disabled={disable}
                    style={{ border: '1px dashed gray', borderRadius: 4, height: 'calc(var(--unit)*' + height + ')', width: '100%' }}
                    tabIndex={-1}
                    role={undefined}
                    component='label'>
                    <Box display='flex' flexDirection='column' alignItems='center' gap={1}>
                        <Avatar sx={{ height: avatarSize, width: avatarSize }}>
                            <UploadFileRounded fontSize={size} />
                        </Avatar>
                        <Typography fontSize={fontPrimarySieze}>Click to upload or drag and drop</Typography>
                        <Typography fontSize={fontSecondarySieze} variant='caption' color='lightgray'>PDF (max. 3MB)</Typography>
                    </Box>
                    <VisuallyHiddenInput multiple type='file' onChange={e => onSelection(e.target.files)} />
                </ButtonBase>
            </form>
        </div>
    )
}

export default FileUpload
